import { render, staticRenderFns } from "./compUserInfo.vue?vue&type=template&id=4024b840&"
import script from "./compUserInfo.vue?vue&type=script&lang=js&"
export * from "./compUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4024b840')) {
      api.createRecord('4024b840', component.options)
    } else {
      api.reload('4024b840', component.options)
    }
    module.hot.accept("./compUserInfo.vue?vue&type=template&id=4024b840&", function () {
      api.rerender('4024b840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/components/compUserInfo.vue"
export default component.exports